import { FormGroup } from "@angular/forms";

export class FormUtil {
  static getFirstError (formGroup: FormGroup, controlName: string): string | null {
    const control = formGroup.controls[controlName];
    if (control.untouched) {
      return "";
    }

    if (control.hasError("required")) {
      return "This field is required.";
    } else if (control.hasError("min")) {
      const minValue = control.getError("min").min;
      return `This value must be greater than or equal to ${minValue}`;
    } else if (control.hasError("max")) {
      const maxValue = control.getError("max").max;
      return `This value must be less than or equal to ${maxValue}`;
    }

    return "";
  }
}
